angular.module('common.directives.googleTranslate', [])

    .directive("googleTranslate", function ($animate, $timeout, $http, $compile) {
        return ({
            restrict: 'A',
            scope: {

            },
            controller: 'GoogleTranslateController',
            controllerAs: 'GoogleTranslateController',
            link: function (scope, element, attrs, parentCtrl) {

                if (!element || !element[0]) return;

                var originalTag = element[0].tagName.toLowerCase();
                var filteredOriginalAttrs = _.filter(element[0].attributes, function (a) { return a.name !== 'google-translate'; });

                var buttonElementId = `trnsltBtn${_.random(0, 1000000)}`;
                scope.buttonElementId = buttonElementId;

                var originalTextElement = $('<span></span>');
                originalTextElement.addClass('original-text-element');
                originalTextElement.attr('ng-hide', 'showTranslation');
                originalTextElement.text(element[0].innerText);
                var originalTextElementTemplate = originalTextElement.outerHtml();

                var buttonTemplate = `<a href="" id="${buttonElementId}" ng-click="doTranslate($event)" title="{{showTranslation ? \'Show original\' : \'See translation\'|translate}}" class="translate-btn long-fade long-fade-in" ng-class="{\'out\':isBusy, \'translate-btn-on\':showTranslation}">` +
                    '<span om-spinner size="0.6em" class="loading-spinner long-fade long-fade-out" ng-class="{in:isBusy}"></span>' +
                    '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" class="">' +
                    '<path d="M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"></path>' +
                    '</svg>' +
                    '</a>';
                var wrapperTemplate = `<${originalTag}>${originalTextElementTemplate}</${originalTag}>`;

                //Compile original element with its scope after we wrapped it with the same tag around for our future manipulations
                var wrappedElement = $compile(wrapperTemplate)(scope.$parent);
                _.forEach(filteredOriginalAttrs, function(oa) { wrappedElement[0].setAttributeNode(oa.cloneNode()); }); //copy original attributes to the wrapper node

                var buttonElement = $compile(buttonTemplate)(scope);
                wrappedElement.append(buttonElement);

                element.replaceWith(wrappedElement);
            }
        });
    })
    .controller('GoogleTranslateController', function ($element, $scope, $http, $compile, $timeout, gettext, uiLocalization, usersRepository) {

        var originalTextWatcherDestructor;

        function init() {
            originalTextWatcherDestructor = $scope.$watch(
                function () {
                    return $element[0].innerHTML;
                },
                function (newVal, oldVal) {

                    //We use jquery to hide/show cause the button has css class animation/transition for opacity applied
                    //and using ng-hide/ng-show gives us a delay when hiding a button
                    if (angular.isUndefined(newVal) || newVal.length === 0) {
                        $(`#${$scope.buttonElementId}`).css('visibility', 'collapse');
                    } else {
                        $(`#${$scope.buttonElementId}`).css('visibility', 'visible');
                    }

                    if (newVal !== oldVal) {
                        $scope.$applyAsync(function() {
                            $scope.showTranslation = false;
                            $scope.$parent.showTranslation = false;
                        });
                    }
                }
            );

            $scope.$on("$destroy", function () {
                if (originalTextWatcherDestructor) {
                    originalTextWatcherDestructor();
                }
            });
        }

        init();

        $scope.doTranslate = function (e) {

            var el = $(e.currentTarget); //the button itself
            el = el.parent(); //element containing element with original text

            if (!el) {
                throw new Error('Not found element/text for translation!');
            }

            var elOriginal = el.find('.original-text-element');
            var textToTranslate = elOriginal.text().trim();

            if ($scope.showTranslation) {
                //Switch back to original if we are showing translation at the moment
                switchTranslatedState();
                return;
            }

            //See if we have translation done already then clear element content to render refreshed content afterwards
            var elTranslated = el.find('.translation-element');
            if (elTranslated && elTranslated.length > 0) {
                elTranslated.remove();
            }

            $scope.isBusy = true;

            usersRepository.getCurrentUser()
                .then(function (user) {

                    var culture = user.getCulture();
                    var language = culture.substr(0, culture.indexOf('-'));

                    $http.post(om.config.build.baseUrl + "/rest-proxy/do-get-request",
                            {
                                uri: `https://clients5.google.com/translate_a/t?client=dict-chrome-ex&sl=auto&tl=${language}&q=${encodeURI(textToTranslate)}`
                            })
                        .then(function (result) {
                                if (result && result.data && result.data[0] && result.data[0][0]) {
                                    $scope.$applyAsync(function () {

                                        elTranslated = $compile(`<span class="translation-element" ng-hide="!showTranslation">${result.data[0][0].toString()}</span>`)($scope);
                                        el.prepend(elTranslated);

                                        $scope.isBusy = false;
                                        switchTranslatedState(true);
                                    });
                                }
                            },
                            function (error) {
                                $scope.$applyAsync(function () {
                                    $scope.isBusy = false;
                                    switchTranslatedState(false);
                                });

                                throw new Error(error);
                            });
                });
        }

        function switchTranslatedState(stateToSet) {
            if (angular.isUndefined(stateToSet) || stateToSet === null) {
                $scope.showTranslation = !$scope.showTranslation;
                $scope.$parent.showTranslation = !$scope.$parent.showTranslation;
            } else {
                $scope.showTranslation = stateToSet;
                $scope.$parent.showTranslation = stateToSet;
            }
        }

    });
